<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="$emit('close')"></button>
      <h2 class="layerTitle">샵 아이템 벌크 업로드</h2>
      <input type="file" id="upload_excel" accept=".xlsx,.xls" @change="onFileChange">
      <div>
        <label for="upload_excel" class="btn" style="width: 50%; margin-right: 30px;">Upload</label>
        <button v-if="bulkData.length > 0" type="button" class="btn btnWhite ml30" @click="cancelUpload">모두 취소</button>
      </div>
      
      <!-- <button type="button" class="btn btnFull sizeL" @click="saveAll">벌크 데이터 저장하기</button> -->
      <div class="itemMessage">
        <p v-if="bulkData.length > 0">총 {{ bulkData.length }}개 아이템</p>
        <p v-else>업로드 아이템이 없습니다.</p>
      </div>

      <p v-if="uploadStatus.total">
        진행률: {{ uploadStatus.percent }}% ({{ uploadStatus.done }} / {{ uploadStatus.total }})
      </p>

      <div class="bulkItems">
        <ul>
          <li v-for="(item, index) in bulkData"
            :key="item.shopItemId">
            [{{index + 1}}] {{ item.shopItemName.ko }} ({{ item.priceInfo.gross }})
          </li>
        </ul>
      </div>

      <div class="btns">
        <button type="button" class="btn btnWhite" @click="$emit('close')">취소</button>
        <button type="button" :disabled="bulkData.length === 0" class="btn btnPrimary" @click="saveAll">업로드 아이템 생성</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'UploadItem',
  props: [
    'locale',
    'shopPageId',
    'defaultLang',
    'categoryId'
  ],
  data () {
    return {
      bulkData: [],
      uploadStatus: {
        running: false,   // 저장 중인지
        total: 0,         // 전체 개수
        done: 0,          // 완료 개수
        success: 0,       // 성공 개수
        fail: 0,          // 실패 개수
        percent: 0,       // 진행률 (0~100)
        currentIndex: 0,  // 지금 처리 중인 index (1부터)
        currentName: ''   // 지금 처리 중인 아이템 이름
      }
    }
  },
  methods: {
    resetUploadStatus () {
      this.uploadStatus = {
        running: false,
        total: 0,
        done: 0,
        success: 0,
        fail: 0,
        percent: 0,
        currentIndex: 0,
        currentName: ''
      }
    },
    /** 모든 업로드 데이터 초기화 */
    cancelUpload () {
      if (confirm('모두 취소하시겠습니까? 다시 업로드 해야 합니다.')) {
        this.bulkData = []
        this.resetUploadStatus()
      }
    },

    /** 파일 선택 핸들러 */
    async onFileChange (e) {
      this.resetUploadStatus()
      const file = e.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[sheetName]

        // 1) 엑셀 → 로우 배열
        const rows = XLSX.utils.sheet_to_json(sheet, {
          defval: '' // 빈 셀은 '' 로
        })

        // 2) 로우 → 내부 포맷으로 변환
        const newItems = this.mapRowsToItems(rows)

        // 3) 기존 bulkData와 merge
        this.mergeBulkData(newItems)

        console.log('[bulkData]', this.bulkData)
      }

      reader.readAsArrayBuffer(file)

      // 동일 파일 다시 업로드해도 이벤트 발생하도록 초기화
      e.target.value = ''
    },

    /** PRICE 문자열 정리 */
    normalizePrice (value) {
      if (!value) return ''
      return String(value).replace(/[^0-9.]/g, '')
    },

    /** 엑셀 → 내부 item 포맷 변환 */
    mapRowsToItems (rows) {
      function normalizeLangKey(key) {
        // key: 'NAME-ko', 'DESC-zh_cn' 같은 형태
        const raw = key.slice(5);        // 'ko', 'zh_cn'
        const lower = raw.toLowerCase(); // 'zh_cn'

        // 중국어 계열: zh_cn → zh-CN, zh_tw → zh-TW
        if (lower.startsWith('zh_')) {
          const [, region] = lower.split('_');   // ['zh', 'cn']
          return `zh-${(region || '').toUpperCase()}`; // zh-CN, zh-TW
        }

        // 나머지는 그냥 소문자 + 언더스코어를 하이픈으로 (필요시)
        // ex) en, ja, ko, en_us → en-us
        return lower.replace('_', '-');
      }

      return rows.map((row) => {
        const shopItemName = {}
        const descObj = {}
        const extraFields = {} // 이름/설명/가격 이외의 필드 모으는 곳

        // 모든 컬럼을 순회
        Object.keys(row).forEach((column) => {
          const key = column.toLowerCase()
          const cell = row[column]
          if (cell === undefined || cell === null || cell === '') return

          // 1) 다국어 이름
          if (key.startsWith('name-')) {
            const lang = normalizeLangKey(key)
            shopItemName[lang] = String(cell).trim()
            return
          }

          // 2) 다국어 설명
          if (key.startsWith('desc-')) {
            const lang = normalizeLangKey(key)
            descObj[lang] = String(cell).trim()
            return
          }

          // 3) 가격 컬럼 → normalizePrice 에서만 사용, extra에는 넣지 않음
          if (key === 'price') {
            return
          }

          // 4) pid -> pId로 키 교체
          if (key === 'pid') {
            extraFields.pId = cell
            return
          }

          // 4) 그 외 모든 컬럼은 문자열로 그대로 살려서 포함
          // 예: thumb, category, code 등
          console.log(key, cell)
          extraFields[key] = String(cell).trim()
        })

        const descList =
          Object.keys(descObj).length > 0 ? [{ desc: descObj }] : []

        const priceRaw = row.PRICE || row.Price || row.price || ''
        const gross = this.normalizePrice(priceRaw)

        console.log(extraFields)

        return {
          // 엑스트라 컬럼들 먼저
          // (shopItemName / descList / priceInfo 같은 핵심 구조가 덮어쓰지 않게)
          ...extraFields,
          shopItemName,
          descList,
          priceInfo: { gross }
        }
      })
    },

    /** uniq id가 안전하게 생성되도록 보장 */
    generateUniqueId () {
      let id = UNIQUE.uniqueId8()
      while (this.bulkData.some(v => v.shopItemId === id)) {
        id = UNIQUE.uniqueId8()
      }
      return id
    },

    /** 엑셀 파싱된 item들을 bulkData에 merge (덮어쓰기 없음) */
    mergeBulkData (newItems) {
      const mapped = newItems.map((item) => ({
        ...item,           // 엑셀에서 넘어온 값 병합
        pageId: this.shopPageId,
        shopItemId: this.generateUniqueId(),
        category: [this.categoryId || 'unknown']
      }))

      this.bulkData = this.bulkData.concat(mapped)
    },

    /** create API */
    async save (data) {
      return await this.$store.dispatch('shop/createShopItem', data)
    },

    /** update API - descList 저장 */
    async update (data) {
      return await this.$store.dispatch('shop/updateShopItem', data)
    },

    /** 모든 아이템 저장(create → update) */
    async saveAll () {
      // 진행률 초기화
      this.resetUploadStatus()
      this.uploadStatus.running = true
      this.uploadStatus.total = this.bulkData.length

      if (confirm('업로드한 아이템을 모두 생성하시겠습니까?')) {
        for (let i = 0; i < this.bulkData.length; i++) {
          const item = this.bulkData[i]
          const nameKo = item.shopItemName.ko || Object.values(item.shopItemName || {})[0] || ''

          // 지금 어느 단계인지 표시
          this.uploadStatus.currentIndex = i + 1
          this.uploadStatus.currentName = nameKo

          try {
            // 1) 생성
            await this.save(item)
            // 2) descList까지 포함해서 업데이트
            await this.update(item)

            this.uploadStatus.success++

            // 결과 플래그 화면에서 보고 싶으면
            this.$set(this.bulkData[i], 'result', true)

            console.log('[saved]', nameKo)
          } catch (e) {
            this.uploadStatus.fail++
            this.$set(this.bulkData[i], 'result', false)
            console.error('[save error]', nameKo, e)
          } finally {
            this.uploadStatus.done++
            this.uploadStatus.percent = Math.round(
              (this.uploadStatus.done / this.uploadStatus.total) * 100
            )
          }
        }

        this.uploadStatus.running = false
        alert('모두 생성되었습니다.')
        this.$emit('complete')
        this.$emit('close')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}
.bulkItems {
  flex: 1;
  overflow: auto;
  padding: 12px;
  font-size: 14px;
  border-radius: 4px;
  background-color: $color-white;
  li + li {
    margin-top: 4px;
  }
}
.itemMessage {
  margin-top: 30px;
  margin-bottom: 5px;
}
</style>
